import { type GlobalSearchResultItem, createGlobalSearchResultItems } from 'models';
import { useQuery } from 'query';
import { getRecentSearches } from '../services';
import { getRecentSearchesQueryKey } from './keys';

export const useRecentSearchesQuery = (enabled: boolean) =>
  useQuery<GlobalSearchResultItem[]>({
    enabled,
    async queryFn() {
      const result = await getRecentSearches();
      return createGlobalSearchResultItems(result.data);
    },
    queryKey: getRecentSearchesQueryKey(),
  });
